import { Pipe, PipeTransform } from '@angular/core';

import { RawColumn } from '../models';
import { filterHiddenColumns } from './filter-hidden-columns.helper';

/**
 * Pipe to hide columns with `hidden` truthy values.
 *
 * If `filterHiddenColumn` is activated in form-section or
 * record details component, column 29 will not appear.
 * it means that column intentionally has been hidden
 * or will be handled in a different
 * component.

 * @example
 * // given
 * { columnId: 29, hidden: true, ...rest }
 * // when
 * <miq-form-section [filterHiddenColumn]="true"...
 * // then column 29 will not be displayed in screen
 */
@Pipe({
  name: 'filterHiddenColumn',
  standalone: false,
})
export class FilterHiddenColumnsPipe implements PipeTransform {
  transform(columns: Array<Pick<RawColumn, 'hidden'>>): any {
    return filterHiddenColumns(columns);
  }
}
